export default [
  {
    key: 'media_id',
    image: 'image_url',
    label: 'Ikon',
    type: 'image',
    notes: [
      'Wajib menggunakan gambar dengan <b>rasio kotak</b>.',
      'e.g. 480 x 480 px, 256 x 256 px, dll.',
    ],
  },
  {
    key: 'name',
    label: 'Nama',
    required: true,
  },
  {
    key: 'parent_category_id',
    label: 'Kategori induk',
    type: 'select',
    text: 'name',
    actionSearch: 'parentCategory/search',
    required: true,
    initialOptions: true,
  },
]
